import {
  Tooltip,
  Legend,
  Pie,
  PieChart,
  Cell,
  ResponsiveContainer
} from "recharts";
import { useState, useEffect } from "react";
import "./Charts.css";
import { handleClickLogic } from "../../utils/filterFunctions";

const MultiPieChart = ({ showData, xKey, title, selectedKey, frozenKey, onBarClick }) => {
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [isFrozen, setIsFrozen] = useState(false);
  const [frozenData, setFrozenData] = useState(null);

  const COLORS = ["#0088FE", "#00C49F", "#FFBB28", "#FF8042", "#AA66CC", "#FF6666", "#66CCFF"];

  const dataToRender = isFrozen ? frozenData : showData;

  const chartKeys = Array.isArray(dataToRender) && dataToRender.length > 0
    ? Object.keys(dataToRender[0]).filter(key => key !== xKey)
    : [];
  useEffect(() => {
    setSelectedCategory(selectedKey);
  }, [selectedKey]);

  useEffect(() => {
    if (frozenKey !== title) {
      setIsFrozen(false);
      setFrozenData(null);
    }
  }, [frozenKey, title]);

  const renderCustomLegend = ({ payload }) => (
    <ul style={{
      listStyle: "none",
      display: "flex",
      flexWrap: "wrap",
      justifyContent: "center",
      padding: 0,
      marginTop: 10
    }}>
      {payload.map((entry, index) => (
        <li
          key={`item-${index}`}
          style={{
            display: "flex",
            alignItems: "center",
            marginRight: 15,
            fontSize: 14,
            color: "#000",
            fontWeight: "500"
          }}
        >
          <span
            style={{
              width: 12,
              height: 12,
              backgroundColor: entry.color,
              display: "inline-block",
              marginRight: 6,
              borderRadius: 2
            }}
          ></span>
          {entry.value}
        </li>
      ))}
    </ul>
  );

  const handleSliceClick = (data) => {
    handleClickLogic({
      data,
      xKey,
      selectedCategory,
      isFrozen,
      showData,
      setIsFrozen,
      setFrozenData,
      setSelectedCategory,
      onBarClick,
    });
  };

  if (!(Array.isArray(dataToRender) && dataToRender.length > 0)) {
    return (
      <div className="chart-card">
        <h3>{title}</h3>
        <div className="chart-body empty">
          <p style={{ textAlign: "center", color: "#888", margin: "20px 0" }}>
            Sin datos disponibles
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="chart-card">
      <h3>{title}</h3>

      <div className="multi-pie-container">
        {chartKeys.map((chartKey) => {
          const dataForChart = dataToRender.map(item => ({
            name: item[xKey],
            total: item[chartKey]
          }));

          const hasData = dataForChart.some(d => d.total > 0);
          if (!hasData) return null;

          return (
            <div key={chartKey} className="pie-wrapper">
              <h4 className="pie-title">{chartKey}</h4>
              <ResponsiveContainer width="100%" height="100%">
                <PieChart>
                  <Pie
                    data={dataForChart}
                    dataKey="total"
                    nameKey="name"
                    cx="50%"
                    cy="50%"
                    innerRadius="70%"
                    outerRadius="100%"
                    paddingAngle={3}
                    label={({ value }) => (
                      <text
                        fill="#fff"
                        textAnchor="middle"
                        dominantBaseline="central"
                        fontSize={13}
                        fontWeight="bold"
                      >
                        {value}
                      </text>
                    )}
                    onClick={(d) => handleSliceClick(d)}
                  >
                    {dataForChart.map((entry, index) => {
                      const isSelected = selectedCategory === entry.name;
                      const opacity = isFrozen
                        ? selectedCategory && !isSelected ? 0.4 : 1
                        : 1;
                      return (
                        <Cell
                          key={`cell-${index}`}
                          fill={COLORS[index % COLORS.length]}
                          stroke={isSelected ? "#333" : "none"}
                          strokeWidth={isSelected ? 2 : 0}
                          fillOpacity={opacity}
                          cursor="pointer"
                        />
                      );
                    })}
                  </Pie>
                  <Tooltip />
                  <Legend content={renderCustomLegend} />
                </PieChart>
              </ResponsiveContainer>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default MultiPieChart;
